<template>
  <div>
    <headline-container headline="Membership Forecast" :breadcrumbs="[{text: 'Membership Forecast'}]"/>

    <div v-if="data !== null" class="container">
      <div class="row">
        <div class="col-xs-6">
          <ParametersPanel v-model="parameters" :portals="portals" @download="download"/>
        </div>

        <div class="col-xs-18">
          <OverviewPanel :data="data"/>

          <ChartPanel :data="data" :year="parameters.year"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import axios from 'axios'
import download from 'downloadjs'
import moment from 'moment'
import store from '@/store'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import ChartPanel from '../../components/Dashboards/MembershipForecast/ChartPanel'
import OverviewPanel from '../../components/Dashboards/MembershipForecast/OverviewPanel'
import ParametersPanel from '../../components/Dashboards/MembershipForecast/ParametersPanel'

export default {
  components: {ParametersPanel, ChartPanel, OverviewPanel, HeadlineContainer},

  data() {
    return {
      data: null,

      portals: null,

      parameters: {
        year: moment().add(1, 'year').format('YYYY'),
        chanceWithRenewal: 80,
        chanceWithoutRenewal: 0,
        priceIncreaseMethod: 'absolute',
        priceIncreaseValue: 0,
        newValue: 0,
        portalId: null
      },

      shared: store
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    parameters: {
      deep: true,
      handler: function () {
        this.load()
      }
    }
  },


  methods: {
    load() {
      Promise.all([
        http.post('/api/v1/reports/membership-forecast', {
          year: this.parameters.year,
          portal_id: this.parameters.portalId,
          chances: {
            with_renewal: this.parameters.chanceWithRenewal,
            without_renewal: this.parameters.chanceWithoutRenewal
          },
          price_increase: {
            method: this.parameters.priceIncreaseMethod,
            value: this.parameters.priceIncreaseValue,
          },
          new_value: this.parameters.newValue
        }),
        http.get('/api/v2/portals')
      ]).then(responses => {
        this.data = responses[0].data.data

        this.portals = responses[1].data.data
      })
    },

    download() {
      axios.post('/api/v1/reports/membership-forecast', {
        year: this.parameters.year,
        portal_id: this.parameters.portalId,
        chances: {
          with_renewal: this.parameters.chanceWithRenewal,
          without_renewal: this.parameters.chanceWithoutRenewal
        },
        price_increase: {
          method: this.parameters.priceIncreaseMethod,
          value: this.parameters.priceIncreaseValue,
        },
        new_value: this.parameters.newValue,
        download: true
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.shared.token
        },
        responseType: 'blob'
      })
          .then(response => {
            download(response.data, response.headers['content-disposition'].slice(22, -1))
          })
    }
  }
}
</script>
